var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccess(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57,
    height: 56,
    viewBox: "0 0 57 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 28C4.5 14.7452 15.2452 4 28.5 4C41.7548 4 52.5 14.7452 52.5 28C52.5 41.2548 41.7548 52 28.5 52C15.2452 52 4.5 41.2548 4.5 28Z",
    fill: "#D1FADF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5 27.08V28C38.4988 30.1564 37.8005 32.2547 36.5093 33.9818C35.2182 35.709 33.4033 36.9725 31.3354 37.5839C29.2674 38.1953 27.0573 38.1219 25.0345 37.3746C23.0117 36.6273 21.2847 35.2461 20.111 33.4371C18.9373 31.628 18.3798 29.4881 18.5217 27.3363C18.6636 25.1846 19.4972 23.1363 20.8983 21.4971C22.2994 19.8578 24.1928 18.7154 26.2962 18.2401C28.3996 17.7649 30.6003 17.9823 32.57 18.86M38.5 20L28.5 30.01L25.5 27.01",
    stroke: "#039855",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 48C17.4543 48 8.5 39.0457 8.5 28H0.5C0.5 43.464 13.036 56 28.5 56V48ZM48.5 28C48.5 39.0457 39.5457 48 28.5 48V56C43.964 56 56.5 43.464 56.5 28H48.5ZM28.5 8C39.5457 8 48.5 16.9543 48.5 28H56.5C56.5 12.536 43.964 0 28.5 0V8ZM28.5 0C13.036 0 0.5 12.536 0.5 28H8.5C8.5 16.9543 17.4543 8 28.5 8V0Z",
    fill: "#ECFDF3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.247ef728dc82bc22dc96513fc9c44429.svg";
export { ForwardRef as ReactComponent };